import { BusinessSlugTypes } from "config";
import { RootState } from "store";

import { createSelector } from "@reduxjs/toolkit";

export const getInsuranceMembership = (state: RootState) => state.insuranceMembership;
export const getActivePolicy = (state: RootState) => state.policy;

export const getInsuranceMembershipId = createSelector(
  getInsuranceMembership,
  insuranceMembership => insuranceMembership.id
);

export const getActiveMembershipBusinesses = createSelector(
  getInsuranceMembership,
  insuranceMember => {
    const activeMembershipsByBusiness: Record<BusinessSlugTypes, boolean> = {
      "wysh-insurance": !!insuranceMember.id,
    };

    return activeMembershipsByBusiness;
  }
);
